<template>
    <div class="appearance-div theme" :id="appearanceID">
        <div v-for="item in processedDatas" :key="item.ID" class="item-div" @click="domClick(item)" :id="item.ID"
            :sort="item.sort">
            <div class="air-div" :style="{ '--air-div-w': item.air + 'px' }"></div>
            <div class="item-icon" v-html="item.icon"></div>
            <div class="content-div">{{ item.name }}</div>
            <div class="item-arrow" v-html="arrowMark.default" v-show="item.childrenCount > 0" :id="item.ID + 'arr'">
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'MenuBar',
    props: {
        /**菜单数据 */
        menuData: {
            type: Array,
            default: () => ([
                { 'index': 1, 'icon': '', 'name': '菜单一', 'children': [{ 'index': 1, 'icon': '', 'name': '子菜单一', 'children': [] }] },
                { 'index': 2, 'icon': '', 'name': '菜单二', 'children': [] },
                { 'index': 3, 'icon': '', 'name': '菜单三', 'children': [] }
            ]),
            validator: (value) => {
                function veriftyData(list) {
                    // 使用 Set 记录当前层级出现过的 index
                    const indexSet = new Set();

                    for (let item of list) {
                        // 1. 校验必要属性
                        if (!(Object.hasOwn(item, 'index') && Object.hasOwn(item, 'name') && Object.hasOwn(item, 'icon') && Object.hasOwn(item, 'children'))) {
                            return false;
                        }
                        // 2. 校验 index 唯一性（性能更优）
                        if (indexSet.has(item.index)) {
                            return false; // 如果 Set 里已经有了，说明重复了
                        }
                        indexSet.add(item.index); // 没重复就加入 Set

                        // 3. 递归校验子菜单
                        if (item.children.length > 0) {
                            if (!veriftyData(item.children)) {
                                return false;
                            }
                        }
                    }
                    return true;
                }
                return veriftyData(value);
            }
        },
        /**
         * 右侧箭头图标
         * 传入参数需是一个字典类型且包含key字段【default】【selected】svg大小在20px
        */
        arrowMark: {
            type: Object,
            default: () => ({
                'default': `<svg t="1779421535965" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9713" width="20" height="20"><path d="M512 756.195443C490.664871 756.938845 469.069808 749.720754 452.782394 734.54117L87.673731 394.266289C56.619735 365.324508 56.619735 318.400611 87.673731 289.45883 118.727726 260.51705 169.076202 260.51705 200.130197 289.45883L512 580.116025 823.869803 289.45883C854.923798 260.51705 905.272274 260.51705 936.32627 289.45883 967.380265 318.400611 967.380265 365.324508 936.32627 394.266289L571.217606 734.54117C554.930192 749.720754 533.335129 756.938845 512 756.195443Z" fill="#979797" p-id="9714"></path></svg>`,
                'selected': `<svg t="1779421535965" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9713" width="20" height="20" transform="rotate(180)"><path d="M512 756.195443C490.664871 756.938845 469.069808 749.720754 452.782394 734.54117L87.673731 394.266289C56.619735 365.324508 56.619735 318.400611 87.673731 289.45883 118.727726 260.51705 169.076202 260.51705 200.130197 289.45883L512 580.116025 823.869803 289.45883C854.923798 260.51705 905.272274 260.51705 936.32627 289.45883 967.380265 318.400611 967.380265 365.324508 936.326269 394.266289L571.217606 734.54117C554.930192 749.720754 533.335129 756.938845 512 756.195443Z" fill="#979797" p-id="9714"></path></svg>`
            }),
            validator: (value) => {
                // 使用更安全的 Object.hasOwn 检查对象自身是否包含这两个键
                return Object.hasOwn(value, 'default') && Object.hasOwn(value, 'selected')
            }
        },
        /**缩进 */
        airNumber: {
            type: Number,
            default: 15
        },
        /**
         * 主题颜色
         * 接受【light】亮色【dark】暗色【customize】自定义
         * 当【customize】自定义时需要传入【customizeTheme】属性
        */
        themeColor: {
            type: String,
            default: 'light',
            validator: (value) => {
                return ['light', 'dark', 'customize'].includes(value);
            }
        },
        /**手风琴模式 */
        accordion: {
            type: Boolean,
            default: false
        },
        /**初始化折叠 */
        initializeFolding: {
            type: Boolean,
            default: false
        },
        /**自定义主题色 */
        customizeTheme: {
            type: Object,
            default: () => ({
                'backgroundColor': '',
                'color': '',
                'menuSelected': '',
                'colorSelected': '',
                'outermostBorder': ''
            })
        },
        /**是否设置项内上下边框
         * 默认列表中第一项为是否显示上下边线，第二项为上下边线样式，如果存在第三项，那么第二项为上边线样式，第三项为下边线样式
         */
        isSetTopBottomBorders: {
            type: Array,
            default: () => ([false, '1px solid #77777736']),
            validator: (value) => {
                if (value.length == 2) {
                    return typeof (value[0]) == 'boolean' && typeof (value[1]) == 'string'
                } else if (value.length == 3) {
                    return typeof (value[0]) == 'boolean' && typeof (value[1]) == 'string' && typeof (value[2]) == 'string'
                } else {
                    confirm('控件传入值错误！');
                    return false
                }

            }
        }

    },
    data() {
        return {
            resizeObserver: null,
            currentlySelectedDom: null,
            initialData: [],
            appearanceID: '',
            expandDict: {},
            run: [false, 'er001'],
            errorMessages: {
                'er001': '未初始化！',
                'er002': '当前为【手风琴模式】无法设定初始折叠状态为展开！请设置【initializeFolding】属性为【true】',
                'er003': '递归错误！未找到数据！',
                'er004': 'themeColor传入值错误！',
                'er005': '传入值customizeTheme不符合要求！或数值为空！',
                'er006': '传入值isSetTopBottomBorders不符合要求！或数值为空！'
            },
            successMessages: {
                'sc001': '初始化成功！'
            },
            processedList: [],
        }
    },
    watch: {
        menuData: {
            handler() { this.rebuildMenu(); },
            deep: true
        },
    },
    methods: {
        rebuildMenu() {
            var menuDatas = JSON.parse(JSON.stringify(this.menuData));
            this.dataProcessing(menuDatas, menuDatas);
            this.initialData = JSON.parse(JSON.stringify(menuDatas));
            this.processedList = this.nestedToFlat(menuDatas);
        },
        generateGUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        /**
         * 寻找深层嵌套中符合要求的第一条数据
         * @param {object} list 嵌套数据列表
         * @param {string} key 判断单条数据中的key字段名称
         * @param {object} value 按照传入key字段判断数据值
         * @returns {boolean | object} 返回符合要求的数据，当未找到或者发生错误时只返回false
         */
        findData(list, key, value) {
            if (key == null || key.toString().replace(/\s+/g, '') == '') {
                console.error('传参错误！');
                return false;
            }
            if (value == null || value.replace(/\s+/g, '') == '') {
                console.error('传参错误！');
                return false;
            }
            for (let item of list) {
                if (item[key] == value) {
                    return item;
                }
                if (item.children.length != 0) {
                    var re = this.findData(item.children, key, value);
                    if (re != false) {
                        return re;
                    }
                }
            }
            return false;
        },
        dataProcessing(originalList, list, parentID = '') {
            list.sort((a, b) => a.index - b.index);
            for (let item of list) {
                item["ID"] = this.generateGUID();
                item["parentID"] = parentID;
                if (this.accordion) {
                    item['choice'] = false;
                } else {
                    item['choice'] = true;
                }
                if (parentID != '') {
                    let re = this.findData(originalList, 'ID', parentID);
                    item['sort'] = re.sort + '.' + item.index;
                    item['air'] = re.air + this.airNumber;
                } else {
                    item['sort'] = item.index.toString();
                    item['air'] = 0;
                }
                if (item.children.length != 0) {
                    item['childrenCount'] = item.children.length;
                    this.dataProcessing(originalList, item.children, item.ID);
                } else {
                    item['childrenCount'] = 0;
                }
            }
        },
        nestedToFlat(list) {
            var datas = [];
            function recursiveF(list_re) {
                for (let item of list_re) {
                    datas.push(item);
                    if (item.childrenCount > 0) {
                        recursiveF(item.children)
                    }
                }
            }
            function deleteChildren(list) {
                for (let item of list) {
                    delete item.children;
                }
            }
            recursiveF(list);
            deleteChildren(datas);
            return datas;
        },
        setMaxHeight() {
            let ap_div = document.getElementById(this.appearanceID);
            if (ap_div && ap_div.parentElement) {
                let parentHeight = ap_div.parentElement.offsetHeight;
                let currentHeight = parseFloat(getComputedStyle(ap_div).height);
                if (Math.abs(parentHeight - currentHeight) > 5) {
                    ap_div.style.setProperty('--ap-h', parentHeight + 'px');
                }
            }
        },
        domClick(dict) {
            if (this.run[0]) {
                this.setChoice(dict.ID);
                this.setArr(dict);
                if (dict.childrenCount == 0) {
                    this.$emit('itemClick', dict);
                    this.setDomBackgronud(dict.ID);
                }
            } else {
                this.throwError();
            }
        },
        setDomBackgronud(ID) {
            let zj = this.processedDatas.filter((item) => { return item.childrenCount == 0; });
            for (let item of zj) {
                document.getElementById(item.ID).style.setProperty('background', '');
                document.getElementById(item.ID).style.setProperty('color', '');
            }
            document.getElementById(ID).style.setProperty('background', `var(--div-bg-${this.themeColor}-selected)`);
            document.getElementById(ID).style.setProperty('color', `var(--div-font-color-${this.themeColor}-selected)`);
        },
        setChoice(ID) {
            this.processedDatas.map((item) => { item.ID == ID ? item.choice = !item.choice : item; return item; });
        },
        setArr(dict) {
            if (this.accordion) {
                this.initArr(dict);
            }
            if (dict.childrenCount > 0) {
                if (dict.choice) {
                    document.getElementById(dict.ID + 'arr').style.setProperty('--item-arrow-tr-ro', '180deg');
                    let ch = this.processedDatas.filter((item) => {
                        return item.parentID == dict.ID;
                    });
                    for (let item of ch) {
                        document.getElementById(item.ID).classList.remove('item-div-fold-up');
                    }
                } else {
                    if (dict.childrenCount > 0) {
                        let parentList = this.findDatasAllchildren(this.initialData, 'parentID', dict.ID);
                        let parentLists = parentList.filter((item) => {
                            return item.childrenCount > 0
                        });
                        for (let item of parentLists) {
                            document.getElementById(item.ID + 'arr').style.setProperty('--item-arrow-tr-ro', '0deg');
                        }
                        for (let item of parentList) {
                            document.getElementById(item.ID).classList.add('item-div-fold-up');
                            item.choice = false;
                            for (let ite of parentList) {
                                this.processedDatas.map((items) => {
                                    items.ID == ite.ID ? (items.choice = false) : items; return items;
                                });
                            }

                        }
                    }
                    document.getElementById(dict.ID + 'arr').style.setProperty('--item-arrow-tr-ro', '0deg');
                }
            }
        },
        initArr(dict) {
            let pr = this.findDataParent(this.initialData, 'ID', dict.ID);
            if (!pr[0]) {
                this.run[1] = this.errorMessages.er003;
                this.run[0] = false;
                this.throwError();
            }
            let listData = [];
            for (let item of this.initialData) {
                if (item.ID != pr[1].ID) {
                    listData.push(...[item]);
                    listData.push(...this.findDatasAllchildren(this.initialData, "parentID", item.ID));
                }
            }
            let fj = listData.filter((item) => { return item.childrenCount > 0; });
            for (let item of fj) {
                document.getElementById(item.ID + 'arr').style.setProperty('--item-arrow-tr-ro', '0deg');
            }
            let ns = listData.filter((item) => { return item.parentID != ''; });
            for (let item of ns) {
                document.getElementById(item.ID).classList.add('item-div-fold-up');
            }
            for (let item of listData) {
                this.processedDatas.map((items) => {
                    items.ID == item.ID ? items.choice = false : items;
                    return items;
                });
            }
        },
        /**
         * 寻找深层嵌套中符合要求的所有数据
         * @param {object} list 嵌套数据列表
         * @param {string} key 判断单条数据中的key字段名称
         * @param {object} value 按照传入key字段判断数据值
         * @returns {Array} [] 返回符合要求的数据
         */
        findDatas(list, key, value) {
            let revertData = [];
            function recursion(list, key, value) {
                for (let item of list) {
                    if (item[key] == value) {
                        revertData.push(item);
                    }
                    if (item.childrenCount > 0) {
                        recursion(item.children, key, value);
                    }
                }
            }
            recursion(list, key, value);
            return revertData;

        },
        /**
         * 寻找深层嵌套中的某一级以下的所有子集数据
         * @param {object} list 嵌套数据列表
         * @param {string} key 判断单条数据中的key字段名称
         * @param {object} value 按照传入key字段判断数据值
         * @returns {Array} [] 返回符合要求的所有子集
         */
        findDatasAllchildren(list, key, value) {
            let revertData = [];
            function recursion(list, key, value, unprocessed) {
                for (let item of list) {
                    if (unprocessed) {
                        revertData.push(item);
                        if (item.childrenCount > 0) {
                            recursion(item.children, key, value, unprocessed);
                        }
                    } else {
                        if (item[key] == value) {
                            revertData.push(item);
                            unprocessed = true;
                        }
                        if (item.childrenCount > 0) {
                            recursion(item.children, key, value, unprocessed);
                        }
                    }
                }

            }
            recursion(list, key, value, false);
            return revertData;
        },
        /**
         * 寻找深层嵌套中的某一级的一级父级并且将父级数据返回
         * @param {object} list 嵌套数据列表
         * @param {string} key 判断单条数据中的key字段名称
         * @param {object} value 按照传入key字段判断数据值
         * @returns {Array} [] 返回列表中存在三个数据[是否找到(Boolean), 父级数据(Object), 是否结束(Boolean)]
         */
        findDataParent(list, key, value) {
            if (list.filter((item) => { return item[key] == value; }).length > 0) {
                if (list[0].parentID == '') {
                    return [true, list.filter((item) => { return item[key] == value; })[0], true];
                } else {
                    return [true, list[0].parentID, false];
                }
            } else {
                for (let item of list) {
                    if (item.childrenCount > 0) {
                        let re = this.findDataParent(item.children, key, value);
                        if (re[0] && re[2] == false) {
                            let res = list.filter((items) => { return items[key] == re[1]; })[0];
                            if (res.parentID == '') {
                                return [true, res, true];
                            } else {
                                return [true, res.parentID, false];
                            }
                        } else if (re[0] && re[2]) {
                            return re;
                        }
                    }

                }
                return [false, null, false];
            }
        },
        throwError() {
            console.error(this.run[1]);
            confirm(this.run[1]);
        },
        initialFoldedState() {
            if (this.accordion && this.initializeFolding == false) {
                this.run[0] = false;
                this.run[1] = this.errorMessages.er002;
                console.warn(this.run[1]);
                return false;
            } else {
                this.run[0] = true;
                this.run[1] = this.successMessages.sc001;
            }
            return this.initializeFolding;
        },
        themeInit() {
            let div = document.getElementById(this.appearanceID);
            if (['light', 'dark'].includes(this.themeColor)) {
                div.style.setProperty('background', `var(--div-bg-${this.themeColor})`);
                div.style.setProperty('color', `var(--div-font-color-${this.themeColor})`);
                for (let item of div.children) {
                    item.classList.add(`menu-item-${this.themeColor}`);
                }
            } else if (this.themeColor == 'customize') {
                if (this.customizeTheme['backgroundColor'] == '') {
                    console.warn('传入值【backgroundColor】为空将默认为【light】主题颜色！');
                }
                if (this.customizeTheme['color'] == '') {
                    console.warn('传入值【color】为空将默认为【light】主题颜色！');
                }
                if (this.customizeTheme['menuSelected'] == '') {
                    console.warn('传入值【menuSelected】为空将默认为【light】主题颜色！');
                }
                if (this.customizeTheme['colorSelected'] == '') {
                    console.warn('传入值【colorSelected】为空将默认为【light】主题颜色！');
                }
                if (this.customizeTheme['outermostBorder'] == '') {
                    console.warn('传入值【outermostBorder】为空将默认为【light】主题颜色！');
                }
                div.style.setProperty('--div-bg-customize', this.customizeTheme['backgroundColor']);
                div.style.setProperty('--div-font-color-customize', this.customizeTheme['color']);
                div.style.setProperty('--div-bg-customize-selected', this.customizeTheme['menuSelected']);
                div.style.setProperty('--div-font-color-customize-selected', this.customizeTheme['colorSelected']);
                div.style.setProperty('--div-appearance-border', this.customizeTheme['outermostBorder']);
                div.style.setProperty('background', `var(--div-bg-${this.themeColor})`);
                div.style.setProperty('color', `var(--div-font-color-${this.themeColor})`);
                for (let item of div.children) {
                    item.classList.add(`menu-item-${this.themeColor}`);
                }
            } else {
                this.run[0] = false;
                this.run[1] = this.errorMessages.er004;
                this.throwError();
            }

            if (this.initialFoldedState()) {
                let ch = this.processedDatas.filter((item) => { return item.parentID != ''; });
                for (let item of ch) {
                    document.getElementById(item.ID).classList.add('item-div-fold-up');
                }
                let pa = this.processedDatas.filter((item) => { return item.childrenCount > 0; });
                for (let item of pa) {
                    document.getElementById(item.ID + 'arr').style.setProperty('--item-arrow-tr-ro', '0deg');
                }
                for (let item of this.processedDatas) {
                    item.choice = false;
                }
            }
            if (this.isSetTopBottomBorders[0]) {
                if (this.isSetTopBottomBorders.length == 2) {
                    for (let item of div.children) {
                        item.style.setProperty('--item-top-border', this.isSetTopBottomBorders[1]);
                        item.style.setProperty('--item-bottom-border', this.isSetTopBottomBorders[1]);
                    }
                } else if (this.isSetTopBottomBorders.length == 3) {
                    for (let item of div.children) {
                        item.style.setProperty('--item-top-border', this.isSetTopBottomBorders[1]);
                        item.style.setProperty('--item-bottom-border', this.isSetTopBottomBorders[2]);
                    }
                } else {
                    this.run[0] = false;
                    this.run[1] = this.errorMessages.er006;
                    this.throwError();
                }
            } else {
                for (let item of div.children) {
                    item.style.setProperty('--item-top-border', '0px');
                    item.style.setProperty('--item-bottom-border', '0px');
                }
            }
        }
    },
    mounted() {
        // 获取当前控件的根 DOM 元素，并找到它的父元素（包裹这个控件的 div）
        const parentEl = this.$el.parentElement;
        if (!parentEl) return;
        // 实例化 ResizeObserver，当父元素尺寸变化时调用 setMaxHeight
        this.resizeObserver = new ResizeObserver(() => {
            this.setMaxHeight();
        });
        // 开始监听父元素
        this.resizeObserver.observe(parentEl);
        // 初始化时也手动调用一次，确保一进来高度就是对的
        this.setMaxHeight();
        this.themeInit();

    },
    computed: {
        processedDatas() {
            return this.processedList;
        },
        safeTheme() {
            const t = this.customizeTheme || {};
            return {
                backgroundColor: t.backgroundColor || 'rgba(255, 255, 255, 1)',
                color: t.color || 'rgba(22, 23, 29, 1)',
                menuSelected: t.menuSelected || 'rgba(220, 220, 220, 1)',
                colorSelected: t.colorSelected || 'rgba(1, 1, 1, 1)',
                outermostBorder: t.outermostBorder || '2px solid #000000',
            };
        }
    },
    beforeUnmount() {
        // 组件销毁前，断开监听，防止内存泄漏
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    created() {
        this.appearanceID = this.generateGUID();
        this.rebuildMenu();
    }
}
</script>

<style scoped>
.theme {
    --div-bg-light: rgba(255, 255, 255, 1);
    --div-font-color-light: rgba(22, 23, 29, 1);
    --div-bg-dark: rgba(22, 23, 29, 1);
    --div-font-color-dark: rgba(255, 255, 255, 1);
    --div-bg-light-selected: rgba(220, 220, 220, 1);
    --div-bg-dark-selected: rgba(1, 1, 1, 1);
    --div-font-color-light-selected: rgba(1, 1, 1, 1);
    --div-font-color-dark-selected: rgba(220, 220, 220, 1);
    --div-bg-customize: rgba(255, 255, 255, 1);
    --div-font-color-customize: rgba(22, 23, 29, 1);
    --div-bg-customize-selected: rgba(220, 220, 220, 1);
    --div-font-color-customize-selected: rgba(255, 255, 255, 1);
    --div-appearance-border: 2px solid #000000;

}

.appearance-div {
    --ap-w: 200px;
    --ap-h: 200px;
    height: var(--ap-h);
    width: var(--ap-w);
    border: var(--div-appearance-border);
    overflow: auto;
    background: var(--div-bg-light);
    color: var(--div-font-color-light);
    cursor: pointer;
}

.item-div {
    --item-h: 50px;
    --item-radius: 0px;
    --item-top-border: 1px solid #77777736;
    --item-bottom-border: 1px solid #77777736;
    width: 100%;
    height: var(--item-h);
    border-radius: var(--item-radius);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    border-top: var(--item-top-border);
    border-bottom: var(--item-bottom-border);
    transition: 0.5s all;
    overflow: clip;
    opacity: 1;
    scrollbar-gutter: stable;
    /* 预留滚动条空间 */
}

.item-div-fold-up {
    height: 0px;
    border-top: 0px solid #77777736;
    border-bottom: 0px solid #77777736;
    opacity: 0;
}

.item-icon {
    --item-icon-w: 20px;
    height: 100%;
    width: var(--item-icon-w);
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.item-arrow {
    --item-arrow-w: 20px;
    --item-arrow-tr-ro: 180deg;
    height: 100%;
    width: var(--item-arrow-w);
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 15px;
    top: 0px;
    transform: rotate(var(--item-arrow-tr-ro));
    transition: 0.5s all;
}

.air-div {
    --air-div-w: 0px;
    height: 100%;
    width: var(--air-div-w);
}

.content-div {
    --content-div-font-weight: 500;
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    font-size: medium;
    font-weight: var(--content-div-font-weight);
}

.menu-item-light:hover {
    background: var(--div-bg-light-selected) !important;
    color: var(--div-font-color-light-selected);

}

.menu-item-dark:hover {
    background: var(--div-bg-dark-selected) !important;
    color: var(--div-font-color-dark-selected);
}

.menu-item-customize:hover {
    background: var(--div-bg-customize-selected) !important;
    color: var(--div-font-color-customize-selected);
}
</style>
